import { render, staticRenderFns } from "./ThayDongHoNuoc.vue?vue&type=template&id=8544ba5c"
import script from "./ThayDongHoNuoc.vue?vue&type=script&lang=js"
export * from "./ThayDongHoNuoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports